export enum ControlType {
  textBox = 1, comboBox = 2, dropDown = 3, autoComplete = 4, numericTextBox = 5, datePicker = 6, multiSelect=7, genericSelector=15
}

